import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { useCollapse as l } from "react-collapsed";
import "classnames";
import "../../../styled-qu50FBLM.mjs";
import "../../Icons/Elements.js";
import a from "../../Icons/Plus.js";
import c from "../../Icons/User.js";
import { useLoginContext as g } from "../context.js";
import "./Dropdown/Dropdown.js";
import { Wrapper as m, Button as d, LoginLeftWrapper as f, UserIconWrapper as h, Text as u, LoginRightWrapper as L, IconWrapper as x } from "./styled.js";
const y = () => {
  const { setIsLoggedIn: t, authManager: i } = g(), e = !1, { getCollapseProps: C, getToggleProps: p } = l({ isExpanded: e }), n = async (s) => {
    s.preventDefault(), await i.signOut(), t(!1);
  };
  return /* @__PURE__ */ o(m, { children: [
    /* @__PURE__ */ o(d, { ...p({ onClick: n }), onClick: n, children: [
      /* @__PURE__ */ o(f, { children: [
        /* @__PURE__ */ r(h, { children: /* @__PURE__ */ r(c, {}) }),
        /* @__PURE__ */ r(u, { children: "Logged in" })
      ] }),
      /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r(x, { children: /* @__PURE__ */ r(a, {}) }) })
    ] }),
    e
  ] });
};
export {
  y as default
};
